import { render, staticRenderFns } from "./CollectedIconTag.vue?vue&type=template&id=784920c0&scoped=true&"
import script from "./CollectedIconTag.vue?vue&type=script&lang=js&"
export * from "./CollectedIconTag.vue?vue&type=script&lang=js&"
import style0 from "./CollectedIconTag.vue?vue&type=style&index=0&id=784920c0&lang=sass&scoped=true&"
import style1 from "./CollectedIconTag.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784920c0",
  null
  
)

export default component.exports